// @flow
import jsonFetch from "common/services/fetch/jsonFetch"

// eslint-disable-next-line flowtype/no-weak-types
export default function fetchLocale(url: string): Promise<Object> {
  return jsonFetch(url)
}
